import { ArrowUp } from "lucide-react";

export enum TableSort {
  ASC = "asc",
  DESC = "desc",
  NONE = 0,
}

export const setSortState = <T extends Record<keyof T, TableSort>>(
  prev: T,
  field: keyof T,
): T => {
  const newSort = {} as { [K in keyof Pick<T, typeof field>]: TableSort };

  for (const sortKey in prev) {
    newSort[sortKey] = TableSort.NONE;
  }

  const currentDirection = prev[field];
  let newDirection: TableSort;

  switch (currentDirection) {
    case TableSort.ASC:
      newDirection = TableSort.DESC;
      break;
    case TableSort.DESC:
      newDirection = TableSort.NONE;
      break;
    default:
      newDirection = TableSort.ASC;
  }

  newSort[field] = newDirection;

  return newSort as T;
};

interface SortTableProps {
  title: string;
  direction: TableSort | undefined;
  disabled?: boolean;
}

export const SortTable = ({ title, direction, disabled }: SortTableProps) => {
  return (
    <span className="flex justify-between">
      {title}
      {!disabled && (
        <ArrowUp
          className={`${direction === TableSort.NONE ? "hidden" : direction === TableSort.ASC ? "rotate-0" : "rotate-180"}`}
        />
      )}
    </span>
  );
};
